export enum KEYS {
  Enter = 'Enter',
  NumEnter = 'NumpadEnter',
  ArrowUp = 'ArrowUp',
  ArrowDown = 'ArrowDown',
  Esc = 'Escape',
}
